
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s",
      function () {
        return require("private-next-pages/s.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s"])
      });
    }
  